var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FilterBaseInputTextMatchType',{staticClass:"filter-app-browse-form",attrs:{"value":_vm.screenName,"match-method":_vm.matchMethod,"prefix":_vm.$t('appBrowsePrefix')},on:{"input-text":_vm.onInputText,"input-match-method":_vm.onInputMatchMethod}})
}
var staticRenderFns = []

export { render, staticRenderFns }